import React from 'react';
import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';

export const ChartGraphSkeleton = () => (
  <Box
    sx={{ mt: 2 }}>
    <Skeleton
      sx={{ width: '100%', height: '200px' }}
    />
  </Box>
);

export const ChartTextSkeleton = () => (
  <Box
    sx={{ mt: 2 }}>
    <Skeleton
      variant='text' sx={{ fontSize: '1rem', width: 350 }}
    />
    <Skeleton
      variant='text' sx={{ fontSize: '1rem', width: 350 }}
    />
  </Box>
);
